export default {
  avatar: {
    title: "Avatarı Değiştir",
  },
  bindRole: {
    allServers: "Tüm Sunucular",
    bindFailed: "Karakter bağlama başarısız",
    bindSuccess: "Karakter bağlı",
    getRoleListFailed: "Karakter listesi alınamadı",
    getServerListFailed: "Sunucu listesi alınamadı",
    modifyTitle: "Bağlı Karakteri Değiştir",
    noRole: "Kullanılabilir karakter yok",
    recentServers: "Sunucunuz",
    role: "Karakter Adı:",
    rolePlaceholder: "Karakter Seç",
    server: "Sunucu:",
    serverPlaceholder: "Sunucu Seç",
    title: "Karakter Bağla",
  },
  commentModal: {
    placeholder: "Yorum yaz...",
    replyTo: "{username} yanıtla",
    title: "Yorum",
  },
  common: {
    cancel: "İptal",
    confirm: "Tamam",
    landscapeTip:
      "Daha iyi bir deneyim için lütfen telefonunuzu dikey moda çevirin",
    loadMore: "Daha fazlası için yukarı kaydırın",
    loading: "Yükleniyor...",
    loadingMore: "Daha fazla yükle...",
    noMore: "Başka veri yok",
    refreshFailed: "Yenilenemedi",
    refreshSuccess: "Yenilendi",
    submit: "Gönder",
    all: "Tümü",
    language: "Dil",
  },
  error: {
    50002: "Geçersiz veya süresi dolmuş jeton",
    50006: "Bu takma ad zaten alınmış",
    50007:
      "Takma adınızı ayda yalnızca bir kez değiştirebilirsiniz, bu ay zaten değiştirdiniz",
    50008: "Yetersiz Puan",
    50301: "Gönderi izniniz yok",
    50302: "Gönderi sınırına ulaşıldı",
    50303: "İçerik uzunluğu gereksinimleri karşılamıyor",
    50304: "İçerik hassas kelimeler içeriyor, lütfen düzenleyip tekrar deneyin",
    50308: "Bu gönderiyi görüntüleme izniniz yok",
    50309: "Gönderi silindi veya taşındı",
    50351: "Konu kapatıldı, yanıt verilemiyor",
    50353: "Yanıtlama izniniz yok",
    50354: "Bu bölümde yanıtlara izin verilmiyor",
    50355: "Çok sık gönderiyorsunuz, lütfen daha sonra tekrar deneyin",
    50356: "Saatlik paylaşım sınırına ulaşıldı",
    50361: "Yorum bulunamadı",
    50500: "Henüz arama işlevini kullanamazsınız",
    50501: "Arama işlevi devre dışı",
    50502: "İçerik hassas kelimeler içeriyor, lütfen düzenleyip tekrar deneyin",
    50505: "Arama çok sık, lütfen daha sonra tekrar deneyin",
    50703: "Görsel İncelemesi Başarısız",
    50704: "Görsel içeriği standartlara uymuyor",
    50214: "Paylaşım başarısız: @:shareModal.alliance üyesi değilsiniz.",
    common: "İşlem başarısız oldu, lütfen daha sonra tekrar deneyin.",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "Giriş Yapıldı",
    loginInSuccess: "Giriş Başarılı",
    pleaseLogin: "Lütfen önce giriş yap.",
    loginNow: "Giriş yap",
    pullToRefresh: "Yenilemek için aşağı kaydır",
    releaseToRefresh: "Yenilemek için bırak",
    signFailed: "Giriş başarısız",
    signIn: "Giriş Yap",
    signInFailedTip: "Giriş başarısız, lütfen daha sonra tekrar deneyin",
    signSuccess: "Giriş Başarılı",
    goToShop: "Puan Merkezine Git",
    sortByLastPost: "Son yorumlar",
    sortByTime: "En Son",
    tags: {
      activity: "Etkinlik",
      chats: "Tartış",
      guide: "Kılavuz",
      recommend: "Öner",
      news: "Haberler",
    },
    unboundRole: "Karakter bağlı değil",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "Bakımda",
    message:
      "Üzgünüz, oyun forumu şu anda bakımda. Lütfen daha sonra tekrar deneyin.",
  },
  mentionModal: {
    searchPlaceholder: "Kullanıcı Ara",
    title: "Kullanıcı Seç",
  },
  nicknameModify: {
    alreadyRenamed:
      "Takma adınızı ayda bir kez değiştirebilirsiniz ve bu ay zaten değiştirdiniz.",
    changedNickname: "Takma Adı Değiştir",
    cost: "Maliyet",
    date: "Tarih",
    getMore: "Al",
    nicknameTooShort: "Takma ad en az 3 karakter olmalı",
    coinNotEnough: "Yetersiz Puan",
    placeholder: "Lütfen Takma Adı Girin",
    recordTitle: "Geçmişi Düzenle",
    sameNickname: "Yeni takma ad mevcut olanla aynı olamaz",
    success: "Değişiklik kaydedildi",
    viewRecord: "Geçmişi Düzenle",
  },
  notice: {
    empty: "Henüz mesaj yok",
    likeComment: "{username} yorumunuzu beğendi",
    likePost: "{username} gönderinizi beğendi",
    mentionComment: "{username} yorumunuzdan bahsetti",
    mentionPost: "{username} gönderinizden bahsetti",
    replyComment: "{username} yorumunuza yanıt verdi",
    replyPost: "{username} gönderinize yanıt verdi",
    system: "Sistem Bildirimi",
    tabs: {
      like: "Beğeni",
      mention: "Benden bahsetti",
      notification: "Bildirim",
      reply: "Bana yanıt verdi",
    },
    title: "Mesaj Bildirimi",
  },
  operateModal: {
    confirmDelete: "Bu gönderiyi silmek istediğinizden emin misiniz?",
    copyFailed: "Kopyalanamadı",
    copyLink: "Bağlantıyı Kopyala",
    copySuccess: "Kopyalandı",
    delete: "Sil",
    shareToGame: "Oyunda paylaş",
    deleteFailed: "Silinemedi",
    deleteSuccess: "Silme Tamamlandı",
    title: "Eylem",
  },
  shareModal: {
    selectChannelTitle: "Lütfen paylaşılacak kanalı seçin",
    channelLabel: "Kanal",
    channelPlaceholder: "Kanal seçin",
    alliance: "İttifak",
    shareSuccess: "Paylaşım başarılı",
    continueBrowse: "Gezinmeye devam et",
    goToGame: "Oyunda görüntüle",
    noThreadTip: "Lütfen önce bir gönderi açın",
  },
  post: {
    create: {
      contentEmpty: "İçerik boş olamaz",
      contentPlaceholder: "Bir şeyler yaz...",
      failed: "Gönderilemedi",
      fileTooLarge: "Dosya boyutu sınırı aşıyor (maks. {maxSize})",
      image: "Görsel",
      imageSizeLimit: "Resim boyutu 5 MB'ın altında olmalı",
      imageUploadFailed: "Resim yüklenemedi",
      imageUploadSuccess: "Resim Yüklendi",
      imageUploading: "Resim yükleniyor, lütfen bekleyin.",
      invalidFileType: "Desteklenmeyen dosya türü",
      maxCharsReached: "Maksimum karakter sınırına ulaşıldı ({max} karakter)",
      mention: "{'@'}",
      selectBoard: "Bölüm Seç",
      topicLabel: "Konu",
      submit: "Gönderi",
      submitting: "Gönderiliyor...",
      success: "Gönderildi",
      title: "Paylaş",
      titleEmpty: "Başlık boş olamaz",
      titlePlaceholder: "Başlık Gir",
      video: "Video",
      videoSizeLimit: "Video boyutu 50 MB'ın altında olmalı",
      videoUploadFailed: "Video yüklenemedi",
      videoUploadSuccess: "Video yüklendi",
      videoUploading: "Video yükleniyor, lütfen bekleyin...",
    },
    title: "Gönderi",
  },
  postDetail: {
    allComments: "Tüm {num} yanıtlar",
    allReplies: "Tümünü Yanıtla",
    author: "Yazar",
    cancelFavorite: "Favorilerden Çıkarıldı",
    commentTooShort: "Yorum en az 5 karakter olmalı",
    translate: "Çevir",
    translating: "Çevriliyor...",
    translateSuccess: "Çeviri başarılı",
    translateFailed: "Çeviri başarısız",
    translatedTo: "Çevrildi",
    earliest: "En Erken Yanıt",
    favoriteSuccess: "Favorilere Eklendi",
    floor:
      'İngilizce forumlarda "kat" kavramı yoktur, "X. kat" ifadesine en yakın kullanım "#X" şeklindedir',
    latest: "En Son Yanıt",
    loadFailed: "Yüklenemedi",
    noContent: "İçerik Yok",
    onlyAuthor: "Sadece Yazar",
    reply: "Yanıtla",
    replyTo: "Yanıtla",
    sendFailed: "Gönderilemedi",
    sendSuccess: "Gönderildi",
    sending: "Gönderiliyor...",
    viewOriginalPost: "Orijinal Gönderi",
    writeSomething: "Bir şeyler söylüyor...",
  },
  profile: {
    addLikeSuccess: "Beğenildi",
    cancelLikeSuccess: "Beğenilmeyenler",
    communityId: "Topluluk Kimliği",
    editNickname: "Takma Adı Değiştir",
    followSuccess: "Takip Ediliyor",
    followed: "Takip Edilenler",
    followers: "Takipçiler",
    follow: "Takip Et",
    likes: "Beğeniler",
    noFavorites: "Favori Yok",
    noPosts: "Güncelleme Yok",
    shopLabel: "Puan Mağazası",
    tabs: {
      favorites: "Favorilerim",
      posts: "Güncellemelerim",
    },
    title: "Profil",
    unfollowSuccess: "Takipten Çıkıldı",
  },
  search: {
    btn: "Ara",
    empty: "İlgili içerik yok",
    filter: {
      dateline: "En Son",
      title: "Sırala",
      views: "Popüler",
    },
    historyTitle: "Arama Geçmişi",
    hotTitle: "Gündemde",
    relatedPosts: "İlgili Gönderiler",
    tabs: {
      post: "Gönderi",
      user: "Kullanıcı",
    },
  },
  setting: {
    about: "Hakkımızda",
    logout: "Çıkış Yap",
    logoutSuccess: "Çıkış Yapıldı",
    privacy: "Gizlilik Politikası",
    service: "Kullanım Koşulları",
    title: "Ayarlar",
  },
  shop: {
    emptyTip: "Mağaza yapım aşamasında, takipte kalın",
    record: "Takas Geçmişi",
    title: "Takas Merkezi",
    bindRole: "Karakteri Bağla",
    switchRole: "Karakter Değiştir",
    tabs: {
      tasks: "Puan görevleri",
      rewards: "Ödül değişimi",
    },
    taskInProgress: "Devam ediyor",
    taskCompleted: "Tamamlandı",
    goToComplete: "Görev",
    exchange: "Değiştir",
    exchanged: "Değiştirildi",
    exchangeConfirmTitle: "Değişimi onayla?",
    currentCoins: "Mevcut puanlar",
    costCoins: "Tüketilecek puanlar",
    receiveRole: "Alıcı karakter",
    exchangeSuccess: "Değişim başarılı",
    exchangeFailed: "Değişim başarısız",
  },
  exchangeRecord: {
    time: "Zaman",
    content: "İçerik",
    points: "Puanlar",
    empty: "Takas kaydı yok",
  },
  tabBar: {
    home: "Ana Sayfa",
    notice: "Mesaj",
    profile: "Benim",
  },
  time: {
    hoursAgo: "{hours} sa. önce",
    minutesAgo: "{minutes} dk önce",
  },
};
